import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter, take, takeUntil, tap } from 'rxjs/operators';
import { BeamerUrlService } from '../../root/beamer-url.service';
import { RegionService } from '../../root/region.service';
import { FracActivityReportPerRegion, FracActivityReportPerRegionWithQualifiedInfo, Region } from '../../types';
import { OwnerDashboardService } from '../owner-dashboard.service';

@Component({
  selector: 'lohi-news-feed',
  templateUrl: './news-feed.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsFeedComponent implements OnInit, OnDestroy {
  public regionsFilterControl = new FormControl('all');
  public regions$: Observable<Region[]>;
  public safeNewsFeedUrl: SafeResourceUrl;
  private destroy$$ = new Subject();

  public fracsActivity$: Observable<FracActivityReportPerRegion[]>;
  public fracsActivityWithQualifiedInfo$: Observable<FracActivityReportPerRegionWithQualifiedInfo>;
  public selectedFracActivity$$ = new BehaviorSubject<FracActivityReportPerRegion>(null);

  constructor(
    private dashboardService: OwnerDashboardService,
    private beamerUrlService: BeamerUrlService,
    private regionService: RegionService,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.regions$ = this.regionService.regions$;
    this.getBeamerUrl('all');
    this.setupFormControls();

    this.fracsActivity$ = this.dashboardService.fracsActivity$.pipe(
      filter((value) => !!value),
      tap((value) => this.selectedFracActivity$$.next(value[0])),
    );
    this.fracsActivityWithQualifiedInfo$ = this.dashboardService.fracsActivityWithQualifiedInfo$.pipe(
      filter((value) => !!value),
    );
  }

  public ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }

  private setupFormControls() {
    this.regionsFilterControl.valueChanges.pipe(takeUntil(this.destroy$$)).subscribe((value) => {
      this.getBeamerUrl(value);
    });
  }

  private getBeamerUrl(segmentFilter: string) {
    this.beamerUrlService
      .getUrl$(segmentFilter)
      .pipe(take(1))
      .subscribe((resp) => {
        if (resp) {
          this.safeNewsFeedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(resp.url);
          this.cd.detectChanges();
        }
      });
  }

  public selectFracActivity(region: FracActivityReportPerRegion): FracActivityReportPerRegion {
    this.selectedFracActivity$$.next(region);
    return region;
  }

  public getActivityReportByRegionId(
    fracsPerRegion: FracActivityReportPerRegion[],
    regionId: number,
  ): FracActivityReportPerRegion {
    if (fracsPerRegion && fracsPerRegion.length > 0) {
      return fracsPerRegion.find((value) => value.regionId === regionId);
    }
    return null;
  }
}
